import { CurrencyPipe, DatePipe, DecimalPipe, NgClass, PercentPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { ETP } from '@zero/crypto/domain';
import { BlinkDirective } from '@zero/shared/ui-directives';
import { IsQuoteOldPipe } from '@zero/shared/ui-pipes';
import { InstrumentDetailsLinkComponent } from '@zero/shared/ui-web-components';
import { commonRoutes } from 'constants/web-app-constants';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'tr[crypto-etp-list-item]',
  templateUrl: './etp-list-item.component.html',
  imports: [
    InstrumentDetailsLinkComponent,
    BlinkDirective,
    NgClass,
    RouterLink,
    DecimalPipe,
    PercentPipe,
    CurrencyPipe,
    DatePipe,
    TranslocoPipe,
    IsQuoteOldPipe,
  ],
})
export class EtpListItemComponent {
  @Input() public etp: ETP;
  @Output() public showStakingRewardModal = new EventEmitter<void>();

  public readonly commonRoutes = commonRoutes;
}
